'use es6';

import { Record, List } from 'immutable';
export default Record({
  active: false,
  award: undefined,
  awardExpiryDays: undefined,
  categories: List(),
  certification: false,
  completed: false,
  deprecated: false,
  deprecationCta: undefined,
  deprecationFinalDate: undefined,
  deprecationMessage: undefined,
  deprecationWarningDate: undefined,
  endOfTrackCtaText: undefined,
  endOfTrackCtaLink: undefined,
  exam: undefined,
  facebookLink: undefined,
  facebookTemplate: undefined,
  featured: false,
  twitterTemplate: undefined,
  lessons: List(),
  displayOrder: undefined,
  description: undefined,
  hasError: false,
  id: undefined,
  icon: undefined,
  isRequesting: false,
  lastValidResult: 0,
  name: undefined,
  passVideo: undefined,
  productAccess: undefined,
  recentError: undefined,
  language: undefined,
  introVideo: undefined,
  studyGuide: undefined,
  status: undefined,
  showDeprecationWarning: false,
  upworkCode: undefined
}, 'Track');